export const isIos =
  // @ts-ignore
  /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);

export const isAndroid = !isIos;
